import { customerSelect } from './customerActions'
import Notify from './notifyActions'

export const USER_LIST = 'USER_LIST'

export const userList = (pager, cid, props) => ({
  type: USER_LIST,
  payload: {
    request: {
      mode: 'no-cors',
      url: (props.location.pathname.indexOf("allusers") >= 0) ? `userlist?=-1` : (cid) ? `userlist?=${cid}` : 'userlist',
      method: 'POST',
      data: pager
    }
  }
})

export const USER_IMPERSONATE = 'USER_IMPERSONATE'

export const userImpersonate = (request) => ({
  type: USER_IMPERSONATE,
  payload: {
    request: {
      mode: 'no-cors',
      url: `login`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: serialize(impersonatestartpayload(request.uid))
    }
  }
})

export const USER_IMPERSONATE_STOP = 'USER_IMPERSONATE_STOP'

export const userImpersonateStop = () => ({
  type: USER_IMPERSONATE_STOP,
  payload: {
    request: {
      mode: 'no-cors',
      url: `login`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: serialize(END_PAYLOAD)
    }
  }
})


function serialize(data) {
  if (!data) return;

  var s = [];

  for (var key in data) {
    s.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
  }

  return s.join('&')
}

function impersonatestartpayload(userid) {
  return { grant_type: 'impersonate_start', userid: userid };
}
export const END_PAYLOAD = { grant_type: 'impersonate_end' }

export const USER_CREATE = 'USER_CREATE'
export const USER_CREATE_SUCCESSFULL_TOAST = 'user_create_successfull_toast'

export const userCreate = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USER_CREATE,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'User',
            method: 'POST',
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(USER_CREATE_SUCCESSFULL_TOAST))
          dispatch(userList(pager))
          resolve();
        } else {
          reject(response.payload.data)
        }
      })
    })

  }
}
export const USER_GET = 'USER_GET'

export const userGet = (id, clearCache = false) => ({
  type: USER_GET,
  payload: {
    request: {
      mode: 'no-cors',
      url: `User/${id}?clearCache=${clearCache}`,
      method: 'GET'
    }
  }
})

export const USER_UPDATE = 'USER_UPDATE'
export const userUpdate = (data) => ({
  type: USER_UPDATE,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'user',
      method: 'PUT',
      data: { request: data }
    }
  }
})

export const USER_UPDATE_WITH_MEASUREMENT_UNIT = 'USER_UPDATE_WITH_MEASUREMENT_UNIT'
export const userUpdateWithMeasurementUnit = (data) => ({
  type: USER_UPDATE_WITH_MEASUREMENT_UNIT,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'user',
      method: 'PUT',
      data: { request: data }
    }
  }
})

export const USER_UPDATE_AND_LIST = 'USER_UPDATE_AND_LIST'
export const USER_UPDATE_SUCCESSFULL_TOAST = 'user_update_successfull_toast'
export const USER_EDIT_PERMISSION_FAILURE_TOAST = 'user_edit_permission_failure_toast'
export const DEFAULT_USER_ROLE_DEGRADATION_NOT_ALLOWED = 'default_user_role_degradation_not_allowed'

export const userUpdateAndList = (data, pager, props) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch(userUpdate(data))
        .then(response => {
          if (response.payload.data.success) {
            dispatch(Notify.success(USER_UPDATE_SUCCESSFULL_TOAST))
            if (data && data.id) {
              dispatch(userGet(data.id))
            }
            if (pager) {
              dispatch(userList(pager, 0, props))
            }
            if (data.Default) {
              let state = getState()
              let customerid = state.profileReducer.profile.customerid
              dispatch(customerSelect(customerid))
            }
            resolve();
          } else {
            if (response.payload.data.errors === "error_duplicateuser") {
              reject(response.payload.data)
            } else if (response.payload.data.errors === "error_role_degradation_not_allowed") {
              dispatch(Notify.success(DEFAULT_USER_ROLE_DEGRADATION_NOT_ALLOWED))
              reject(response.payload.data)
            } else {
              dispatch(Notify.success(USER_EDIT_PERMISSION_FAILURE_TOAST))
              reject(response.payload.data)
            }
          }
        })
    })
  }
}

export const USER_RESET = 'USER_RESET'

export const userReset = () => ({
  type: USER_RESET,
  payload: {}
})

export const USER_DELETE = 'USER_DELETE'
export const USER_DELETE_SUCCESSFULL_TOAST = 'user_delete_successfull_toast'
export const USER_DELETE_FAILURE_TOAST = 'user_delete_failure_toast'
export const USER_DELETE_PERMISSION_FAILURE_TOAST = 'user_delete_permission_failure_toast'

export const userDelete = (id, pager, props) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: USER_DELETE,
        payload: {
          request: {
            mode: 'no-cors',
            url: `User/${id}`,
            method: 'DELETE'
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(USER_DELETE_SUCCESSFULL_TOAST))
        } else {
          let state = getState()
          let currentLoggedInUserId = state.profileReducer.profile.id
          if (currentLoggedInUserId === id) {
            dispatch(Notify.success(USER_DELETE_FAILURE_TOAST))
          }
          else {
            dispatch(Notify.success(USER_DELETE_PERMISSION_FAILURE_TOAST))
          }
        }
        if (pager) {
          dispatch(userList(pager, 0, props))
        }
        resolve(response.payload.data.success);
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export const USER_TOGGLE_ENABLE = 'USER_TOGGLE_ENABLE'
export const USER_TOGGLE_ENABLE_SUCCESSFULL_TOAST = 'user_toggle_enable_successfull_toast'
export const USER_TOGGLE_DISABLE_SUCCESSFULL_TOAST = 'user_toggle_disable_successfull_toast'
export const USER_TOGGLE_DISABLE_FAILURE_TOAST = 'user_toggle_disable_failure_toast'
export const USER_DISABLE_PERMISSION_FAILURE_TOAST = 'user_disable_permission_failure_toast'

export const userToggleEnable = (id, wasEnabled, pager, props) => {
  return (dispatch, getState) => {
    dispatch({
      type: USER_TOGGLE_ENABLE,
      payload: {
        request: {
          mode: 'no-cors',
          url: `/User/ToggleDisableField/${id}`,
          method: 'PUT'
        }
      }
    }).then(response => {
      if (response.payload.data.success) {
        if (wasEnabled) {
          dispatch(Notify.success(USER_TOGGLE_DISABLE_SUCCESSFULL_TOAST))
        } else {
          dispatch(Notify.success(USER_TOGGLE_ENABLE_SUCCESSFULL_TOAST))
        }
      } else {
        let state = getState()
        let currentLoggedInUserId = state.profileReducer.profile.id
        if (currentLoggedInUserId === id) {
          dispatch(Notify.success(USER_TOGGLE_DISABLE_FAILURE_TOAST))
        }
        else {
          dispatch(Notify.success(USER_DISABLE_PERMISSION_FAILURE_TOAST))
        }
      }
      if (pager) {
        dispatch(userList(pager, 0, props))
      }
    }).catch(error => {

    })
  }
}

export const USER_IMPERSONATE_RESET = 'USER_IMPERSONATE_RESET'

export const userImpersonateReset = () => ({
  type: USER_IMPERSONATE_RESET,
  payload: {}
})

export const USERS_RESET = 'USERS_RESET'

export const usersReset = () => ({
  type: USERS_RESET,
  payload: {}
})

export const SOFTWARE_UPDATE_STOP = 'SOFTWARE_UPDATE_STOP'

export const softwareUpdateStop = () => ({
  type: SOFTWARE_UPDATE_STOP,
  payload: {}
});

export const GET_SOFTWARE_UPDATE = 'GET_SOFTWARE_UPDATE';

export const getSoftwareUpdate = () => ({
  type: GET_SOFTWARE_UPDATE,
  payload: {
    request: {
      mode: 'no-cors',
      url: `/DeviceSoftware`,
      method: 'GET'
    }
  }
});


// WEBPACK FOOTER //
// ./src/redux/actions/userActions.js